import { createSlice } from '@reduxjs/toolkit'
import StoreValueModel from "../StoreValueModel"
import LoaderCommonsModel from "./LoaderCommonsModel"

const initialState: LoaderCommonsModel = {
    locations: new StoreValueModel(),
    locationInfo: new StoreValueModel(),
    provinces: new StoreValueModel()
}

export const counterSlice = createSlice({
    name: 'loaderCommons',
    initialState,
    reducers: {
        reducerLoadLocations: (state, action) =>
        {
            state.locations = action.payload
        },
        reducerLoadProvinces: (state, action) =>
        {
            state.provinces = action.payload
        }
    },
})

export const { reducerLoadLocations, reducerLoadProvinces } = counterSlice.actions
export default counterSlice.reducer
